import { createReducer } from '@reduxjs/toolkit'
import { DictT, RoomTypeT } from 'types/model'
import { receiveRoomTypes, clear, logout } from 'model/actions'

const initialState = {} as DictT<RoomTypeT>

const roomTypesReducer = createReducer(initialState, builder => {
  builder
    .addCase(receiveRoomTypes, (state, action) => action.payload)
    .addCase(clear, () => initialState)
    .addCase(logout, () => initialState)
})

export default roomTypesReducer
